// extracted by mini-css-extract-plugin
module.exports = {"register":"register_register__b3Mms"};